import { createMuiTheme } from '@material-ui/core/styles';
import {
  Theme as MuiTheme,
  ThemeOptions
} from '@material-ui/core/styles/createMuiTheme';
import {
  StylesProvider,
  ThemeProvider as MuiThemeProvider
} from '@material-ui/styles';
import React from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';

const defaults: ThemeOptions = {
  palette: {
    primary: {
      main: '#0076bf'
    },
    secondary: {
      main: '#004a88'
    }
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(',')
  },
  overrides: {
    MuiFormControlLabel: {
      label: { width: '100%' }
    },
    MuiLinearProgress: {
      colorPrimary: { backgroundColor: 'rgba(158, 202, 230, 0.3)' } // TODO: Get value from theme?
    }
  }
};

/**
 * Use custom Material UI theme in both Styled components and Material UI.
 */
export const Theme: React.FC<ThemeOptions> = ({ children, ...rest }) => {
  const theme = createMuiTheme({ ...defaults, ...rest });

  return (
    <StyledComponentsThemeProvider theme={theme}>
      <StylesProvider injectFirst>
        <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
      </StylesProvider>
    </StyledComponentsThemeProvider>
  );
};

/**
 * Enables Material UI theme intellisense.
 */
declare module 'styled-components' {
  export interface DefaultTheme extends MuiTheme {}
}
